import { user } from 'ampersand-app'
import config from '@/config'

// actions
const ACTION_PREFIX = 'tenant/logo'
const SET_DATA = `${ACTION_PREFIX}/setData`
const SET_ERROR = `${ACTION_PREFIX}/setError`
const SET_DMS_TOKEN = `${ACTION_PREFIX}/setDmsToken`
const RESET_DMS_TOKEN_SESSION = `${ACTION_PREFIX}/resetDmsTokenSession`

export const getDmsTokenContextKey = (sessionEpoch, collaborationId = 'internal') =>
  `${sessionEpoch}|${collaborationId || 'internal'}`

const initialState = {
  tenantLogoEmail: null,
  tenantLogoCustomerCenter: null,
  showLogoInEmail: false,
  showLogoInCustomerCenter: false,
  taxRateCountryCodes: [config.defaultCountryAsISO2],
  dmsTokenSessionEpoch: 0,
}

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA: {
      const { data, dmsTokenSessionEpoch } = action
      const currentSessionEpoch = state.dmsTokenSessionEpoch ?? 0
      if (dmsTokenSessionEpoch !== currentSessionEpoch) return state
      // clear a previous error so a successful retry is distinguishable from a failed one
      // DMS token omission is meaningful: login bootstrap may return the direct URLs without a
      // token. Never preserve a token from the previous session/tenant through this merge.
      return {
        ...state,
        ...data,
        dmsToken: data.dmsToken,
        dmsTokenContextKey: data.dmsToken
          ? getDmsTokenContextKey(currentSessionEpoch, 'internal')
          : null,
        error: null,
      }
    }
    case SET_ERROR: {
      const { error, dmsTokenSessionEpoch } = action
      if (dmsTokenSessionEpoch !== (state.dmsTokenSessionEpoch ?? 0)) return state
      return { ...state, error }
    }
    case SET_DMS_TOKEN: {
      const currentSessionEpoch = state.dmsTokenSessionEpoch ?? 0
      if (action.dmsTokenSessionEpoch !== currentSessionEpoch) return state
      return {
        ...state,
        dmsToken: action.dmsToken,
        dmsTokenContextKey: action.dmsToken
          ? getDmsTokenContextKey(currentSessionEpoch, action.collaborationId)
          : null,
      }
    }
    case RESET_DMS_TOKEN_SESSION:
      return {
        ...state,
        dmsToken: undefined,
        dmsTokenContextKey: null,
        dmsTokenSessionEpoch: (state.dmsTokenSessionEpoch ?? 0) + 1,
      }
    default:
      return state
  }
};

export const updateData = (data, dmsTokenSessionEpoch) => {
  return {
    type: SET_DATA,
    data,
    dmsTokenSessionEpoch,
  }
}

export const setError = (error, dmsTokenSessionEpoch) => {
  return {
    type: SET_ERROR,
    error,
    dmsTokenSessionEpoch,
  }
}

export const setDmsToken = (dmsToken, collaborationId = 'internal', dmsTokenSessionEpoch) => ({
  type: SET_DMS_TOKEN,
  dmsToken,
  collaborationId,
  dmsTokenSessionEpoch,
})

export const resetDmsTokenSession = () => ({ type: RESET_DMS_TOKEN_SESSION })

export const fetchData = () => {
  return (dispatch, getState) => {
    const dmsTokenSessionEpoch = getState().tenant.settings.dmsTokenSessionEpoch ?? 0
    return user.getTenantSetting()
      .then(({ body: { data } }) => {
        dispatch(updateData(data, dmsTokenSessionEpoch))
      })
      .catch((error) => {
        dispatch(setError(error, dmsTokenSessionEpoch))
      })
  }
}
